import React from "react";

export const Logo: React.FC = () => <img src="julies-angels.jpg" className="logo"></img>;
